import { type ReactElement, useState } from 'react';
import { useReloadReviewDetail } from '@/entities/review';
import { Button } from '@/shared/ui';

interface ReviewConflictNoticeProps {
  readonly reviewId: string;
  /** 새로 불러온 뒤 호출부의 충돌 상태를 지운다. */
  readonly onReloaded: () => void;
}

const RELOAD_FAILED_MESSAGE = '다시 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.';
const CONFLICT_MESSAGE = '후기가 바뀌었습니다. 새로 불러온 뒤 다시 시도해 주세요.';

/** 충돌 안내 + "새로 불러오기" — 상세는 자동으로 다시 불리지 않아 눌러야 최신 수정 시각을 받는다. */
export const ReviewConflictNotice = ({
  reviewId,
  onReloaded,
}: ReviewConflictNoticeProps): ReactElement => {
  const reload = useReloadReviewDetail();
  const [failed, setFailed] = useState(false);
  const reloadNow = async (): Promise<void> => {
    setFailed(false);
    try {
      await reload(reviewId);
    } catch {
      setFailed(true);
      return;
    }
    onReloaded();
  };
  return (
    <div role="alert" className="flex flex-col items-start gap-2 text-sm text-destructive">
      <p>{CONFLICT_MESSAGE}</p>
      {failed && <p>{RELOAD_FAILED_MESSAGE}</p>}
      <Button type="button" variant="outline" size="sm" onClick={() => void reloadNow()}>
        새로 불러오기
      </Button>
    </div>
  );
};
